import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'CollectionFavorites',
  props: {
  color: {
    type: String,
    default: undefined
  }
},
  setup(__props) {




const collections = useCollectionsStore()
const { favorites } = storeToRefs(collections)
const favoriteItems = computed(() => favorites.value.models.sort((a: any, b: any) => {
  return a.name.localeCompare(b.name)
}))


return (_ctx: any,_cache: any) => {
  const _component_CollectionListing = _resolveComponent("CollectionListing")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_hy_icon = _resolveComponent("hy-icon")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item = _resolveComponent("v-list-item")!

  return (_unref(collections).hasFavorites)
    ? (_openBlock(), _createBlock(_component_CollectionListing, {
        key: 0,
        collection: _unref(favoriteItems),
        color: __props.color,
        favorites: ""
      }, null, 8, ["collection", "color"]))
    : (_openBlock(), _createBlock(_component_v_list_item, { key: 1 }, {
        default: _withCtx(() => [
          _createVNode(_component_v_list_item_title, null, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createTextVNode(" No favorites ", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_v_list_item_subtitle, null, {
            default: _withCtx(() => [
              _cache[1] || (_cache[1] = _createTextVNode(" Add some by clicking on ", -1)),
              _createVNode(_component_hy_icon, {
                name: "Favorite",
                tiny: ""
              }),
              _cache[2] || (_cache[2] = _createTextVNode(" next to your favorite items ", -1))
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
}
}

})